import { apiClient } from '@/core/api/client';
import { GrupoAdminSchema, GruposListSchema, PermisosListSchema, UsuarioAdminSchema, UsuariosPaginadosSchema, } from '@/data/dto/admin';
const BASE = '/api/gestion/v1/admin';
export const adminApi = {
    // Usuarios
    async listarUsuarios(filtros) {
        const res = await apiClient.get(`${BASE}/usuarios`, { params: filtros });
        return UsuariosPaginadosSchema.parse(res.data);
    },
    async crearUsuario(v) {
        const payload = {
            email: v.email,
            nombre: v.nombre,
            apellido: v.apellido,
            password: v.password,
            grupoIds: v.grupoIds,
            personaTipo: v.personaTipo || null,
            personaId: v.personaId || null,
        };
        const res = await apiClient.post(`${BASE}/usuarios`, payload);
        return UsuarioAdminSchema.parse(res.data);
    },
    async editarUsuario(id, v) {
        const payload = {
            email: v.email,
            nombre: v.nombre,
            apellido: v.apellido,
            grupoIds: v.grupoIds,
            personaTipo: v.personaTipo || null,
            personaId: v.personaId || null,
        };
        if (v.password)
            payload.password = v.password;
        const res = await apiClient.patch(`${BASE}/usuarios/${id}`, payload);
        return UsuarioAdminSchema.parse(res.data);
    },
    async cambiarEstadoUsuario(id, activo) {
        const res = await apiClient.patch(`${BASE}/usuarios/${id}/estado`, { activo });
        return UsuarioAdminSchema.parse(res.data);
    },
    // Grupos
    async listarGrupos() {
        const res = await apiClient.get(`${BASE}/grupos`);
        return GruposListSchema.parse(res.data).items;
    },
    async crearGrupo(v) {
        const res = await apiClient.post(`${BASE}/grupos`, v);
        return GrupoAdminSchema.parse(res.data);
    },
    async editarGrupo(id, v) {
        const res = await apiClient.patch(`${BASE}/grupos/${id}`, v);
        return GrupoAdminSchema.parse(res.data);
    },
    async desactivarGrupo(id) {
        await apiClient.delete(`${BASE}/grupos/${id}`);
    },
    // Permisos
    async listarPermisos() {
        const res = await apiClient.get(`${BASE}/permisos`);
        return PermisosListSchema.parse(res.data).items;
    },
};
